import {
  Box,
  Button,
  CircularProgress,
  Grid2,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { viewPDF } from "../../utils/viewPDF";
import axios from "axios";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { handleExportPDF } from "../../utils/exportToPDF";

const ViewRFQDetails = () => {
  const [rfq, setRfq] = useState();
  const { rfqId } = useParams();
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [itemsLoading, setItemsLoading] = useState(true);
  const [exporting, setExporting] = useState(false);
  const vendorId = JSON.parse(localStorage.getItem("vendor"));
  const pdfRef = useRef();

  useEffect(() => {
    const getRFQ = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/vendor-rfq/get-rfq?rfqId=${rfqId}&vendorId=${vendorId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
        );
        setRfq(res.data);
        setItemsLoading(false);
      } catch (error) {
        console.log(error);
      }
    };
    getRFQ();
  }, []);

  const groupedWorkItems = rfq?.rfqWorkItems?.reduce((acc, item) => {
    if (!acc[item.section]) {
      acc[item.section] = [];
    }
    acc[item.section].push(item);
    return acc;
  }, {});

  const handleBack = () => {
    navigate("/vendor/dashboard");
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const [date, time] = dateString.split("T");
    const [year, month, day] = date.split("-");
    const cleanTime = time?.split(".")[0];
    return `${day}/${month}/${year} ${cleanTime}`;
  };

  return (
    <div>
      {exporting && (
        <div className="uploading-div">
          Exporting PDF... This may take a while.{" "}
          <CircularProgress color="#fff" />
        </div>
      )}
      <div style={{ display: "flex", justifyContent: "end", gap: 50 }}>
        {(["BID_CLOSED", "BID_SUBMITTED", "REBID", "AWARDED"].includes(
          rfq?.vrStatus,
        ) ||
          (rfq?.vrStatus === "DISQUALIFIED" &&
            rfq?.stage !== "FINANCE_HEAD" &&
            rfq?.stage !== "BUYER")) && (
          <div
            className="tender-card"
            style={{
              background: "#EFE6F6",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-around",
              cursor: "pointer",
            }}
            onClick={() => navigate(`/vendor/dashboard/${rfqId}/view-bids`)}
          >
            <div style={{ display: "flex", alignItems: "center", justifyContent: "end" }}>
              <div
                style={{
                  borderRadius: "50%",
                  background: "#fff",
                  padding: "10px",
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                <ShowChartIcon />
              </div>
            </div>
            <Typography fontWeight={600}>View Quotes Submitted</Typography>
          </div>
        )}
        <div
          className="tender-card"
          style={{
            background: "#FCEAE4",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
            cursor: "pointer",
          }}
          onClick={() => navigate(`/vendor/dashboard/${rfqId}/view-query`)}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "end" }}>
            <div
              style={{
                borderRadius: "50%",
                background: "#fff",
                padding: "10px",
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              <DescriptionOutlinedIcon />
            </div>
          </div>
          <Typography fontWeight={600}>Queries</Typography>
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "end" }}>
        <Button
          className="btn-contained"
          sx={{ width: "200px" }}
          onClick={async () => {
            try {
              setExporting(true);
              await handleExportPDF(pdfRef, "RFQ_Details");
            } catch (e) {
              console.log(e);
            } finally {
              setExporting(false);
            }
          }}
        >
          Export PDF
        </Button>
      </div>

      <div ref={pdfRef}>
        <Box className="dashboard-container" px={10}>
          <Typography className="form-title">RFQ Details</Typography>
          <Grid2 container>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderTop: "1px solid #000" }}
            >
              RFQ ID
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{
                borderTop: "1px solid #000",
                borderRight: "1px solid #000",
              }}
            >
              {rfq && rfq.rfqId}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Creation Date
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{
                borderRight: "1px solid #000",
              }}
            >
              {rfq && formatDateTime(rfq.creationDate)}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">Submission Date</Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid" sx={{ borderRight: "1px solid #000" }}>
              {rfq && formatDateTime(rfq.submissionDate)}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">Comments/Brief about RFQ</Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid" sx={{ borderRight: "1px solid #000" }}>
              {rfq && rfq.brief}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">Attachments</Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid" sx={{ borderRight: "1px solid #000" }}>
              {rfq && rfq.document && (
                <Button
                  sx={{ margin: "0 0 0 -15px !important", padding: "0 !important", width: "auto !important", fontSize: "12px !important", textDecoration: "underline", textAlign: "start" }}
                  onClick={() => viewPDF(rfq.document, storedUser)}
                >
                  View
                </Button>
              )}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">Name</Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid" sx={{ borderRight: "1px solid #000" }}>
              {rfq && rfq.name}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">Email ID</Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid" sx={{ borderRight: "1px solid #000" }}>
              {rfq && rfq.email}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">Department</Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid" sx={{ borderRight: "1px solid #000" }}>
              {rfq && rfq.dept}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">Delivery period (Lead Time)</Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid" sx={{ borderRight: "1px solid #000" }}>
              {rfq && rfq?.term1}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">Payment Terms</Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid" sx={{ borderRight: "1px solid #000" }}>
              {rfq && rfq?.term2}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">Freight</Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid" sx={{ borderRight: "1px solid #000" }}>
              {rfq && rfq?.term3}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">Price Basis (Incoterms)</Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid" sx={{ borderRight: "1px solid #000" }}>
              {rfq && rfq?.term4}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">Warranty Period</Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid" sx={{ borderRight: "1px solid #000" }}>
              {rfq && rfq?.term5}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">Late Delivery Clause</Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid" sx={{ borderRight: "1px solid #000" }}>
              {rfq && rfq?.term6}
            </Grid2>
          </Grid2>
        </Box>

        <h2>Work Items Details</h2>
        <Box className="dashboard-container" px={10}>
          <table border={1} style={{ borderCollapse: "collapse", width: "100%", marginTop: "10px" }}>
            <thead>
              <tr>
                <th style={{ padding: "20px" }}>Item Code</th>
                <th style={{ width: "60%" }}>Description</th>
                <th>Item Group</th>
                <th>UOM</th>
                <th>Quantity</th>
                <th>GST (in %)</th>
              </tr>
            </thead>
            <tbody>
              {itemsLoading
                ? "Loading..."
                : groupedWorkItems &&
                  Object.entries(groupedWorkItems).map(
                    ([section, items], sectionIndex) => {
                      return (
                        <React.Fragment key={sectionIndex}>
                          <tr
                            style={{
                              backgroundColor: "#d8e9f0",
                              fontWeight: "bold",
                            }}
                          >
                            <td
                              colSpan={7}
                              style={{ textAlign: "left", padding: "10px" }}
                            >
                              {section}
                            </td>
                          </tr>
                          {items
                            .sort((a, b) => a.itemOrder - b.itemOrder)
                            .map((item, index) => (
                              <tr key={index} style={{ textAlign: "center" }}>
                                <td style={{ padding: "20px" }}>{item.code}</td>
                                <td>{item.description}</td>
                                <td>{item.section}</td>
                                <td>{item.unit}</td>
                                <td>{item.quantity}</td>
                                <td>{item.gst}</td>
                              </tr>
                            ))}
                        </React.Fragment>
                      );
                    },
                  )}
            </tbody>
          </table>
        </Box>
      </div>

      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
      </Box>
    </div>
  );
};

export default ViewRFQDetails;
